import { PRODUCT_NAME } from '../product';
import { LOGO_BLOCK, LOGO_INK, LOGO_MONOGRAM, LOGO_VIEWBOX } from './brandPaths';

export interface BrandLogoProps {
  /** The drawn height in px; the width follows the wordmark's own proportions. */
  height?: number;
  className?: string;
  testID?: string;
}

/**
 * The wordmark (D-1268): Jason's "AdOrchestrator" as vectors — the "Ad" white on the Lagoon block, the
 * note-d, the tilted "O" with its sweep, "rchestrator" in the text colour. One drawing serves both themes:
 * the block is `--color-primary`, the "Ad" is the on-primary white, the rest is `currentColor`.
 *
 * It is an image to a screen reader, named after the product; the icon rail and the phone draw the "Ad"
 * mark (`BrandMark`) where 26 px is all there is.
 */
export function BrandLogo({ height = 28, className, testID }: BrandLogoProps) {
  const width = Math.round((height * LOGO_VIEWBOX.width) / LOGO_VIEWBOX.height);
  return (
    <svg
      viewBox={`${LOGO_VIEWBOX.x} ${LOGO_VIEWBOX.y} ${LOGO_VIEWBOX.width} ${LOGO_VIEWBOX.height}`}
      width={width}
      height={height}
      role="img"
      aria-label={PRODUCT_NAME}
      focusable="false"
      className={className}
      data-testid={testID}
    >
      <rect
        x={LOGO_BLOCK.x}
        y={LOGO_BLOCK.y}
        width={LOGO_BLOCK.width}
        height={LOGO_BLOCK.height}
        rx={LOGO_BLOCK.rx}
        fill="var(--color-primary)"
      />
      <path d={LOGO_MONOGRAM} fill="var(--color-text-on-primary)" />
      <path d={LOGO_INK} fill="currentColor" />
    </svg>
  );
}
